var NODE_ENV = process.env.NODE_ENV || 'production';
var ACTIVITY_URL = '//manhattan.webapp.xiaojukeji.com/candy/activity/home';
if (NODE_ENV === 'development' || NODE_ENV === 'test') {
    ACTIVITY_URL = '//manhattan.webapp.xiaojukeji.com:9500/activity/home';
}
if (NODE_ENV === 'preview') {
    ACTIVITY_URL = '//pre.intra.webapp.manhattan.xiaojukeji.com/candy/activity/home';
}
export default { ACTIVITY_URL: ACTIVITY_URL };
